import { type GridFilterModel } from "@mui/x-data-grid-pro";
import { useCallback, useState } from "react";

const EMPTY_FILTER_MODEL: GridFilterModel = {
	items: [],
	quickFilterValues: [],
	quickFilterExcludeHiddenColumns: true,
};

export default function useGridQuickFilterModel(initial: GridFilterModel = EMPTY_FILTER_MODEL) {
	const [gridFilterModel, setGridFilterModel] = useState<GridFilterModel>(initial);
	const [quickFilterInput, setQuickFilterInput] = useState("");

	const onQuickFilterSearchChange = useCallback((value: string) => {
		setQuickFilterInput(value);
		setGridFilterModel((prev) => ({
			...prev,
			quickFilterValues: value ? [value] : [],
		}));
	}, []);

	const handleFilterModelChange = useCallback((model: GridFilterModel) => {
		setGridFilterModel(model);
		if (!model.quickFilterValues?.length) {
			setQuickFilterInput("");
		}
	}, []);

	return {
		gridFilterModel,
		onFilterModelChange: handleFilterModelChange,
		quickFilterSearchProps: {
			searchValue: quickFilterInput,
			onSearchChange: onQuickFilterSearchChange,
		},
	};
}
